<script setup>
import { ref, onMounted, computed, watch } from 'vue'
import { Row, Toggle, Hints, Heading, Input, Select } from '@components'
import DarkModeStore from '@o/store'
const { options, isPro, isLocked } = DarkModeStore()
import Ajax from '../../../common/ajax';


const reportInterval = ref(1)
const reportIntervals = {
    1: 'Last 24 Hours',
    7: 'Last 7 Days',
    30: 'Last 30 Days',
    365: 'Last 1 Year',
}

import AnalyticsChart from './AnalyticsChart.vue';

</script>

<template>
    <Row transparent gap="5" :data-wp-dark-mode-locked="isLocked">
        <!-- graph settings  -->
        <Row space gap="5">
            <Row transparent>
                <Toggle locked v-model="options.analytics_enabled">Dark Mode Analytics </Toggle>
                <Hints>Enable Dark Mode Analytics to show how much users use teh dark mode each day </Hints>
            </Row>
            <Row :blur="!options.analytics_enabled || !isPro" :locked="true" :ProBadge="false">
                
                <AnalyticsChart />
            </Row>
            <Row transparent :blur="!options.analytics_enabled || !isPro">
                <Toggle locked v-model="options.analytics_enabled_dashboard_widget">Display this dark mode usage chart on
                    the WordPress Dashboard </Toggle>
                    
                <Hints>If you enable this then the chart above will be shown in your admin panel dashboard</Hints>
            </Row>
        </Row>
        <!-- Reporting  -->
        <Row space gap="5">
            <Row transparent :blur="!options.analytics_enabled" locked :ProBadge="false">
                <Toggle v-model="options.analytics_enabled_email_reporting">Email Reporting <ProBadge /></Toggle>
                <Hints>Enable this feature to get the dark mode usage summery through email.</Hints>
            </Row>
            <Row transparent :blur="!options.analytics_enabled_email_reporting || !options.analytics_enabled" locked
                :ProBadge="false">
                <Heading>Reporting Frequency <Hints>Select the reporting frequency when the email will be send.</Hints>
                </Heading>
                <div class="w-40">
                    <Select v-model="options.analytics_email_reporting_frequency" :options="$default.analytics.email_reporting_frequency.options"> </Select>
                </div>
            </Row>
            <Row transparent :blur="!options.analytics_enabled_email_reporting || !options.analytics_enabled" locked
                :ProBadge="false">
                <Heading>Reporting Email <Hints>Enter the email where analytics report will be sent</Hints>
                </Heading>
                <Input v-model="options.analytics_email_reporting_address" placeholder="john.doe@mail.com" />
            </Row>
            <Row transparent :blur="!options.analytics_enabled_email_reporting || !options.analytics_enabled" locked
                :ProBadge="false">
                <Heading>Reporting Email Subject <Hints>Subject of the analytics report mail</Hints>
                </Heading>
                <Input v-model="options.analytics_email_reporting_subject"
                    placeholder="Weekly Dark Mode Usage Summary of [domain name]" />
            </Row>
        </Row>
    </Row>
</template>
